import { mapState } from 'vuex';

export default {
  props: {
    height : Number,
    width  : {
      type    : Number,
      default : 420
    },
    position: {
      type    : String,
      default : function() {
        return 'left center';
      }
    }
  },
  data() {
    return {
      observer         : null,
      hasINDBlackWhite : false
    };
  },
  mounted() {
    this.observer = new MutationObserver(mutations => {
      for (const m of mutations) {
        this.$nextTick(() => {
          this.onClassChange(m.target.getAttribute(m.attributeName));
        });
      }
    });

    this.observer.observe(document.body, {
      attributes      : true,
      attributeFilter : ['class']
    });

    this.onClassChange(document.body.className);
  },
  beforeDestroy() {
    this.observer.disconnect();
  },
  methods: {
    onClassChange(classList) {
      if (classList?.includes('INDblackwhite')) {
        this.hasINDBlackWhite = true;
      } else {
        this.hasINDBlackWhite = false;
      }
    }
  },
  computed: {
    ...mapState({
      logoLight : (state) => state._core.application.logo.light,
      logoDark  : (state) => state._core.application.logo.dark
    }),
    logo() {
      return (this.$vuetify.theme.dark || this.hasINDBlackWhite) ? this.logoDark : this.logoLight;
    }
  }
};
